import { render } from "./SettingOffcanvas.vue?vue&type=template&id=4bcee81e"
import script from "./SettingOffcanvas.vue?vue&type=script&lang=js"
export * from "./SettingOffcanvas.vue?vue&type=script&lang=js"

import "./SettingOffcanvas.vue?vue&type=style&index=0&id=4bcee81e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__